var render = function render(){var _vm=this,_c=_vm._self._c;return _c('embed-iframe',{attrs:{"title":"Progress bar Widget","name":"double-goal-mete-widget","height":_vm.height,"css":_vm.css}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }